"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _enums = require("MeetingsBase/constants/enums");

var defaults = {
  firstName: '',
  lastName: '',
  email: '',
  customFormFields: (0, _immutable.Map)()
};

var constructCustomFormFields = function constructCustomFormFields(prefillObj) {
  var formFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var fields = formFields.reduce(function (acc, field) {
    var prefillValue = prefillObj[field.name];

    if (!prefillValue) {
      return acc;
    }

    if (field.fieldType === _enums.FORM_FIELD_TYPES.BOOLEAN_CHECKBOX) {
      return acc.set(field.name, JSON.parse(prefillValue));
    } else if (field.fieldType === _enums.FORM_FIELD_TYPES.CHECKBOX) {
      return acc.set(field.name, prefillValue.split(';'));
    } else {
      return acc.set(field.name, prefillValue);
    }
  }, (0, _immutable.Map)());
  return fields;
};

var FormPrefills =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(FormPrefills, _Record);

  function FormPrefills() {
    (0, _classCallCheck2.default)(this, FormPrefills);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FormPrefills).apply(this, arguments));
  }

  (0, _createClass2.default)(FormPrefills, null, [{
    key: "from",
    value: function from(json, formFields) {
      var firstname = json.firstname,
          lastname = json.lastname,
          email = json.email,
          rest = (0, _objectWithoutProperties2.default)(json, ["firstname", "lastname", "email"]);
      return new FormPrefills({
        firstName: firstname,
        lastName: lastname,
        email: email,
        customFormFields: constructCustomFormFields(rest, formFields)
      });
    }
  }]);
  return FormPrefills;
}((0, _immutable.Record)(defaults));

exports.default = FormPrefills;
module.exports = exports.default;